"use client";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Star } from "lucide-react";

interface ReviewProps {
  image: string;
  name: string;
  userName: string;
  comment: string;
  rating: number;
}

const reviewList: ReviewProps[] = [
  {
    image: "https://example.com/user1.jpg",
    name: "Sarah W",
    userName: "Satisfied Customer",
    comment:
      "This system has streamlined our operations—easy order tracking and happy customers!",
    rating: 5.0,
  },
  {
    image: "https://example.com/user2.jpg",
    name: "Michael S",
    userName: "Satisfied Customer",
    comment:
      "Order processing has never been smoother. From check-in to checkout, everything is seamless and fast!",
    rating: 4.9,
  },
  {
    image: "https://example.com/user3.jpg",
    name: "Sophia",
    userName: "Satisfied Customer",
    comment:
      "Business analytics help us make smarter decisions and boost our revenue.",
    rating: 5.0,
  },
  {
    image: "https://example.com/user4.jpg",
    name: "James",
    userName: "Satisfied Customer",
    comment:
      "This system has revolutionized our order flow. No more confusion or delays—orders are processed in no time.",
    rating: 4.7,
  },
];

export const TestimonialSection = () => {
  return (
    <section id="testimonials" className="container py-20 sm:py-8 overflow-x-hidden">
      <div className="text-center mb-8 mt-20">
        <h2 className="text-lg text-primary text-center mb-2 tracking-wider">
          Testimonials
        </h2>

        <h2 className="text-3xl md:text-4xl text-center font-bold mb-4">
          See What Our Happy Clients Are Saying
        </h2>
      </div>

      <Carousel
        opts={{
          align: "start",
        }}
        className="relative w-[80%] sm:w-[90%] lg:max-w-screen-xl mx-auto"
      >
        <CarouselContent>
          {reviewList.map((review) => (
            <CarouselItem
              key={review.name}
              className="md:basis-1/2 lg:basis-1/3"
            >
              <Card className="bg-muted/50 dark:bg-card">
                <CardContent className="pt-6 pb-0">
                  <div className="flex gap-1 pb-6">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`size-4 ${
                          i < Math.round(review.rating)
                            ? "fill-primary text-primary"
                            : "text-muted"
                        }`}
                      />
                    ))}
                  </div>
                  {`"${review.comment}"`}
                </CardContent>

                <CardHeader>
                  <div className="flex flex-row items-center gap-4">
                    <Avatar>
                      <AvatarImage src={review.image} alt={review.name} />
                      <AvatarFallback>
                        {review.name
                          .split(" ")
                          .map((n) => n[0])
                          .join("")}
                      </AvatarFallback>
                    </Avatar>

                    <div className="flex flex-col">
                      <CardTitle className="text-lg">{review.name}</CardTitle>
                      <CardDescription>{review.userName}</CardDescription>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
    </section>
  );
};
